module.exports = new __parcel__URL__("crash_7.6a40b51c.mp3").toString();